<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
    <template #DETAILS="{ visible, params }">
      <Tracker v-if="visible" :statusId="params.row.airway_number"></Tracker>
    </template>
  </cTable>
</template>

<script>
import { getPodError, confirmError } from "@/api/storage/pod_error";
import { getCountry } from "@/api/system/country";
import { getAgent } from "@/api/tracker/agent";
import cTable from "@/base/common/index";
import Tracker from "@/base/order_tracker";
export default {
  name: "podError",
  components: {
    cTable,
    Tracker,
  },
  async mounted() {
    let country = (await getCountry({ allow_arrive: 1 })).data.payload.rows;
    let agent = (await getAgent()).data.payload.rows;
    this.header.searchs.forEach((item) => {
      if (item.key === "to_country") item.options = country;
      if (item.key === "agent") item.options = agent;
    });
  },
  data() {
    return {
      methods: {
        list: getPodError,
        confirmError,
      },
      modals: {
        hand: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("confirmError", row)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                    duration: 5,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            rules: {
              content: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              status: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
            },
            formBind: {
              labelWidth: 100,
            },
            title: this.$t("handle"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{ status: 24 }, { content: 24 }],
          fields: [
            {
              name: () => this.$t("handle") + this.$t("exlType"),
              key: "status",
              placeholder() {
                return this.$t("handle") + this.$t("exlType");
              },
              component: "Radio",
              options: [
                {
                  value: 1,
                  label:
                    this.$t("reserve") + this.$t("now") + this.$t("trajectory"),
                },
                {
                  value: 2,
                  label: this.$t("hide") + "POD" + this.$t("trajectory"),
                },
              ],
              bind: {
                border: true,
              },
            },
            {
              key: "content",
              name: () => this.$t("handling_opinions"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("handling_opinions");
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 600,
            },
          },
          footer: { show: () => false },
        },
      },
      header: {
        searchs: [
          {
            key: "status",
            placeholder() {
              return this.$t("handle") + this.$t("exlType");
            },
            component: "Select",
            options: [
              { value: "ALL", label: this.$t("all") },
              { value: 0, label: this.$t("n_process") },
              {
                value: 1,
                label:
                  this.$t("reserve") + this.$t("now") + this.$t("trajectory"),
              },
              {
                value: 2,
                label: this.$t("hide") + " POD" + this.$t("trajectory"),
              },
            ],
            default: "ALL",
            clearable: false,
          },
          {
            key: "to_country",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            component: "Select",
            options: [],
            config: {
              label: "code",
              value: "code",
            },
          },
          {
            key: "agent",
            placeholder() {
              return this.$t("select") + this.$t("agentName");
            },
            component: "Select",
            options: [],
            config: {
              label: "agent_name",
              value: "agent_name",
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          show: false,
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_number",
          align: "left",
          component: "Button",
          copy: true,
          width: 150,
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            click({ row }) {
              this.$page.getModal("showDetails").setTitle(row.airway_number);
              // this.getModal("writeOff").type = "writeOff";
              this.$page.getModal("showDetails").open({ row });
            },
          },
        },
        {
          name: this.$t("order_t") + this.$t("createTime"),
          key: "create_time",
          align: "center",
          width: 170,
        },
        {
          name: () => this.$t("tracker_code"),
          key: "status",
          align: "center",
          width: 80,
        },

        {
          name: () => this.$t("tracker_description"),
          key: "status_remarks",
          align: "center",
        },
        // {
        //   name: () => this.$t("tracker_description_cn"),
        //   key: "status_cn",
        //   align: "center"
        // },
        {
          name: () => this.$t("status_time"),
          key: "status_time",
          align: "center",
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
          align: "center",
          width: 80,
        },
        {
          name: () => this.$t("agentName"),
          key: "deliver",
          align: "left",
        },
        {
          name: () => this.$t("order_refCode"),
          key: "agent_refer_code",
          align: "left",
        },
        {
          name: () => this.$t("handle") + this.$t("exlType"),
          key: "operation_status",
          align: "center",
        },
        {
          name: () => this.$t("handling_opinions"),
          key: "content",
          align: "left",
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          align: "left",
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",

          list: [
            {
              name: () => this.$t("handle"),
              type: "hand",
              fnName: "hand",
              bind: {
                type: "warning",
              },
              id: 1186,
            },
          ],

          methods: {
            hand({ row }) {
              this.getModal("hand").open({ awbno: row.airway_number });
            },
          },
        },
      ],
    };
  },
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
